<template>
  <v-tooltip v-bind="$attrs" bottom v-if="tooltip">
    <template v-bind="$attrs" v-slot:activator="{ on }">
      <v-icon small v-on="on" color="grey lighten-1">fas fa-question-circle</v-icon>
    </template>
    <span>{{ tooltip }}</span>
  </v-tooltip>
</template>

<script>
export default {
  inheritAttrs: true,

  props: {
    tooltip: {
      type: String
    }
  }
}
</script>
